export default __webpack_public_path__ + "static/time-3baa86ad5d0920eda5927167f96a578b.png";